var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEllipsisHealth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 40,
    viewBox: "0 0 89 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.373 18.2622C2.58352 21.5445 4.74781 24.5819 8.45295 24.5819C10.7216 24.5819 12.6445 23.9541 13.8668 21.6497L15.5429 22.732C14.1817 25.2804 11.2116 26.6077 8.62718 26.6077C3.03907 26.6077 0 22.557 0 17.5636C0 12.5359 3.70333 8.7301 8.34859 8.7301C12.7497 8.7301 15.9277 12.466 15.9277 16.6909C15.9277 17.2498 15.8578 17.9474 15.8233 18.2622H2.373ZM8.34587 10.755C5.06269 10.755 2.93199 13.0593 2.44287 16.2364H13.5846C13.4458 13.3732 11.2452 10.755 8.34587 10.755Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1637 26.1886H18.7889V0H21.1637V26.1886Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.975 26.1886H25.6002V0H27.975V26.1886Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4116 5.34261V2.0603H34.7864V5.34261H32.4116ZM32.4116 26.1886V9.14837H34.7864V26.1886H32.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5968 9.14833V11.3483C42.8891 9.63732 44.9844 8.7301 47.0806 8.7301C52.0716 8.7301 55.8121 12.7454 55.8121 17.599C55.8121 22.4526 52.0426 26.6077 47.0452 26.6077C45.1241 26.6077 43.0642 25.8746 41.6005 24.5129V35.4793H39.222V9.14833H41.5968ZM41.5968 21.7586C42.8537 23.3998 45.0542 24.4476 47.0107 24.4476C50.7122 24.4476 53.3674 21.3749 53.3674 17.7433C53.3674 14.0763 50.7476 10.8993 47.0107 10.8993C44.9145 10.8993 42.5751 12.1213 41.5968 14.1117V21.7586Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6399 11.977C65.6961 11.2431 64.4393 10.755 63.1825 10.755C61.854 10.755 60.1779 11.488 60.1779 13.0947C60.1779 15.1196 62.3785 15.7828 64.5437 16.6909C66.6399 17.5636 68.7007 18.7512 68.7007 21.7885C68.7007 24.7923 65.5573 26.6077 62.6934 26.6077C61.7022 26.6114 60.7211 26.4083 59.8128 26.0116C58.9045 25.6148 58.089 25.033 57.4183 24.3033L58.8485 22.8019C59.8612 23.8842 61.1534 24.5819 62.7605 24.5819C64.4021 24.5819 66.3223 23.7091 66.3223 21.7541C66.3223 19.799 64.5074 19.1005 62.5854 18.3321C60.3503 17.4248 57.9401 16.4115 57.9401 13.3043C57.9401 10.3703 60.3848 8.7301 63.2487 8.7301C65.0301 8.7301 66.6063 9.28804 67.9294 10.3703L66.6399 11.977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.0538 5.34261V2.0603H74.4286V5.34261H72.0538ZM72.0538 26.1886V9.14837H74.4286V26.1886H72.0538Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.828 11.977C85.8843 11.2431 84.6275 10.755 83.3697 10.755C82.0421 10.755 80.3661 11.488 80.3661 13.0947C80.3661 15.1196 82.5666 15.7828 84.7318 16.6909C86.828 17.5637 88.8889 18.7512 88.8889 21.7886C88.8889 24.7923 85.7445 26.6077 82.8806 26.6077C81.8896 26.6112 80.9087 26.4081 80.0006 26.0114C79.0924 25.6146 78.2771 25.0329 77.6065 24.3033L79.0384 22.8019C80.0521 23.8842 81.3443 24.5819 82.9505 24.5819C84.5921 24.5819 86.5132 23.7091 86.5132 21.7541C86.5132 19.799 84.6983 19.1005 82.7763 18.3321C80.5412 17.4248 78.1301 16.4115 78.1301 13.3043C78.1301 10.3703 80.5802 8.7301 83.4396 8.7301C85.2209 8.7301 86.7972 9.28804 88.1194 10.3703L86.828 11.977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4645 39.9973V36.656H47.7703V39.9973H46.3692V32.3767H47.7703V35.5002H51.4645V32.3794H52.8656V40L51.4645 39.9973Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1624 39.9973V32.3767H60.0999V33.5298H56.5608V35.5003H60.0999V36.6533H56.5608V38.8406H60.0999V39.9946L55.1624 39.9973Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.609 32.3794H65.7733L68.7679 40H67.1626L66.609 38.4976H63.5591L62.9937 40H61.4583L64.609 32.3794ZM63.9883 37.3636H66.1916L65.1099 34.436H65.0981L63.9883 37.3636Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3078 39.9973V32.3767H71.708V38.8406H75.0293V39.9946L70.3078 39.9973Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3533 33.5325V39.9973H76.9522V33.5325H75.033V32.3794H80.2735V33.5325H78.3533Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8625 39.9973V36.656H83.1683V39.9973H81.7672V32.3767H83.1683V35.5002H86.8625V32.3794H88.2636V40L86.8625 39.9973Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.69703 39.9982C9.80747 39.9982 11.5183 38.2878 11.5183 36.1779C11.5183 34.0681 9.80747 32.3577 7.69703 32.3577C5.58658 32.3577 3.87573 34.0681 3.87573 36.1779C3.87573 38.2878 5.58658 39.9982 7.69703 39.9982Z",
    fill: "#81DE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2317 39.9982C21.3421 39.9982 23.053 38.2878 23.053 36.1779C23.053 34.0681 21.3421 32.3577 19.2317 32.3577C17.1213 32.3577 15.4104 34.0681 15.4104 36.1779C15.4104 38.2878 17.1213 39.9982 19.2317 39.9982Z",
    fill: "#3ABAB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7664 39.9982C32.8768 39.9982 34.5877 38.2878 34.5877 36.1779C34.5877 34.0681 32.8768 32.3577 30.7664 32.3577C28.6559 32.3577 26.9451 34.0681 26.9451 36.1779C26.9451 38.2878 28.6559 39.9982 30.7664 39.9982Z",
    fill: "#5687D6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_17"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88.8889,
    height: 40,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipsisHealth);
export default __webpack_public_path__ + "static/media/ellipsis-health.91233292f56e709028adced2e87ca3ca.svg";
export { ForwardRef as ReactComponent };